// import axios from 'axios';
// export const baseURL = 'https://anomla.net/account-web/api/';
// const axiosInstance = axios.create({
//   baseURL: baseURL,
//   timeout:30000,
//   headers: {
//     // 'Content-Type': 'multipart/form-data',
//     "Accept": "application/json",
//     'X-API-KEY': 'development101010102020203030',
//   }
// });

// export default axiosInstance;

import axios from "axios";
import { toast } from "react-toastify";
import { progressStore } from "../components/GlobalLoader/progressStore";

const axiosInstance = axios.create({
  baseURL: "https://anomla.net/account-web/api/",
  timeout: 60000,
  headers: { Accept: "application/json" },
});

// Request Interceptor (for token/company)
axiosInstance.interceptors.request.use((config) => {
  const url = config.url || "";
  const endpoint = url.split("/").pop().replace(/-/g, " ").replace(/_/g, " ");
  const label = endpoint
    ? endpoint.charAt(0).toUpperCase() + endpoint.slice(1)
    : "Loading";

  if (!config.hideProgress) {
    progressStore.startRequest(label);
  }

  config.onUploadProgress = (evt) => {
    if (config.hideProgress) return;
    if (evt.total) {
      const pct = Math.round((evt.loaded / evt.total) * 100);
      progressStore.setUpload(pct, evt.loaded, evt.total);
    } else {
      const simulated = Math.min(95, Math.round((evt.loaded / 50000) * 100));
      progressStore.setUpload(simulated, evt.loaded, 0);
    }
  };

  config.onDownloadProgress = (evt) => {
    if (config.hideProgress) return;
    if (evt.total) {
      const pct = Math.round((evt.loaded / evt.total) * 100);
      progressStore.setDownload(pct, evt.loaded, evt.total);
    } else {
      const simulated = Math.min(95, Math.round((evt.loaded / 100000) * 100));
      progressStore.setDownload(simulated, evt.loaded, 0);
    }
  };

  const token = localStorage.getItem("token");
  const companyId = localStorage.getItem("company_id");

  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (companyId) config.headers["X-Company-ID"] = companyId;
  config.headers["X-API-KEY"] = "development101010102020203030";
  return config;
});

// Response Interceptor (Central Error Handling)
axiosInstance.interceptors.response.use(
  (response) => {
    if (!response.config?.hideProgress) {
      const state = progressStore.getState();
      progressStore.setUpload(
        100,
        state.uploadTotal || state.uploadLoaded,
        state.uploadTotal || state.uploadLoaded,
      );
      progressStore.setDownload(
        100,
        state.downloadTotal || state.downloadLoaded,
        state.downloadTotal || state.downloadLoaded,
      );
      setTimeout(() => progressStore.endRequest(), 80);
    }
    return response;
  },
  async (error) => {
    if (!error.config?.hideProgress) {
      progressStore.setUpload(100);
      progressStore.setDownload(100);
      setTimeout(() => progressStore.endRequest(), 80);
    }

    const config = error.config || {};

    // Handle timeout specifically and allow a single retry
    const isTimeout =
      error?.code === "ECONNABORTED" ||
      (error?.message || "").toLowerCase().includes("timeout");
    if (isTimeout) {
      // initialize retry counter
      config.__retryCount = config.__retryCount || 0;
      const MAX_RETRIES = 1;
      if (config.__retryCount < MAX_RETRIES) {
        config.__retryCount += 1;
        toast.info("Request timed out. Retrying...");
        try {
          return axiosInstance(config);
        } catch (e) {
          // fall through to error handling below
        }
      }
      toast.error("Request timed out. Please try again.");
      return Promise.reject(error);
    }

    // 1️Network Error (no response)
    if (!error.response) {
      console.error("Network error:", error);
      toast.error(
        error?.message || "Network error! Please check your connection.",
      );
      return Promise.reject(error);
    }

    const { status, data } = error.response;

    //  Unauthorized → logout
    if (status === 401) {
      toast.error("Session expired. Redirecting to login...");
      localStorage.clear();
      window.location.href = "/login";
      return Promise.reject(data);
    }

    //  Forbidden → Access Denied
    if (status === 403) {
      toast.error("Access Denied: You do not have permission.");
      return Promise.reject(data);
    }

    //  Server Error 5xx → optional retry or show error
    if (status >= 500) {
      toast.error("Server error! Please try again later.");
      return Promise.reject(data);
    }

    //  Other errors (400 / validation)
    if (data?.message) {
      toast.error(data.message); // API-provided message
    }

    return Promise.reject(data);
  },
);

export default axiosInstance;
